document.addEventListener( 'DOMContentLoaded', function() {
	addRelativePositionToParent( '.ae-block-feat-img-caption' );
});

function addRelativePositionToParent( selector ) {
	const elements = document.querySelectorAll( selector );

	elements.forEach( ( element ) => {
		const parent = element.parentElement;
		if ( parent ) {
			parent.style.position = 'relative';
			parent.style.width = '100%';
			parent.style.height = '100%';
		}
	});
}
